import React from "react";
import {Delete, translate} from "admin-on-rest";
import StoreMessageDataList from "./StoreMessageDataList";
import StoreMessageShowItem from "./StoreMessageShowItem";
import StoreMessageEditForm from "./StoreMessageEditForm";
import StoreMessageCreateForm from "./StoreMessageCreateForm";

///////////////////// LIST ALL STORE MESSAGES /////////////////////
export const StoreMessageList = props => <StoreMessageDataList {...props} />;

///////////////////// SHOW  STORE MESSAGE /////////////////////
export const StoreMessageShow = props => <StoreMessageShowItem {...props} />;

///////////////////// UPDATE STORE MESSAGES /////////////////////
export const StoreMessageEdit = props => <StoreMessageEditForm {...props} />;

///////////////////// CREATE NEW STORE MESSAGES /////////////////////
export const StoreMessageCreate = props => (
  <StoreMessageCreateForm {...props} />
);

///////////////////// DELETE STORE MESSAGES /////////////////////

const StoreMessageDeleteTitleBase = ({record, translate}) => (
  <span>
    {translate("aor.action.delete")}&nbsp;
    {record && <img src={`${record.avatar}?size=25x25`} width="25" alt="" />}
    {record && `${record.first_name} ${record.last_name}`}
  </span>
);

const StoreMessageDeleteTitle = translate(StoreMessageDeleteTitleBase);

export const StoreMessageDelete = props => (
  <Delete {...props} title={<StoreMessageDeleteTitle />} />
);



// WEBPACK FOOTER //
// ./src/containers/CRM/StoreMessages/index.js